<template>
  <el-dialog title="重置密码" :visible.sync="currentValue" width="408px" custom-class="reset-password-dialog" :close-on-click-modal="false">
    <RestPassword @restSuccess="success" ref="dialog" :defaultMobile="defaultMobile"></RestPassword>
    <template #footer>
      <span class="cancel text-btn-active" @click="currentValue = false" style="margin-right: 24px;">取消</span>
      <wf-button style="margin-right:10px;"  type="primary" @click="modifyPass">保 存</wf-button>
    </template>
  </el-dialog>
</template>
<script>
import RestPassword from '@/layouts/restPasswork/dialog'
export default {
  components: {
    RestPassword
  },
  props: ['value', 'defaultMobile'],
  data() {
    return {
      passLoading: false,
    }
  },
  computed: {
    currentValue: {
      get() {
        return this.value
      },
      set(val) {
        if(!val) {
          this.$refs.dialog.resetFields()
        }
        this.$emit('input', val)
      }
    }
  },
  methods: {
    success() {
      this.currentValue = false
    },
    modifyPass() {
      this.$refs.dialog.resetPassword()
    }
  }
}
</script>
<style lang="scss">
.reset-password-dialog {
  .el-form {
    .el-form-item__label {
      line-height: 1.3;
      padding-bottom: 8px;
    }
    .el-form-item:last-child {
      margin: 0;
    }
  }
  .el-dialog__body {
    padding-top: 10px;
    padding-bottom: 0;
  }
  .el-dialog__footer {
    padding-top: 24px;
  }
}
</style>
